/* eslint-disable max-len */
import preloader from './icons/preloader';
import social from './icons/social';
import about from './icons/about';
import offer from './icons/offer';
import estimation from './icons/estimation';

export default {
    preloader,
    social,
    about,
    offer,
    estimation
};



// WEBPACK FOOTER //
// ./src/data/icons.js